import * as SharedPermissionsActions from './shared-permissions.actions';

export {SharedPermissionsActions};
